import { GALLERY_TAG, URLS } from '@/lib/consts';
import type { ServiceURLs } from '../../types';

/*
 * Gallery Section Identifiers
 */
export const GALLERY_SECTION_ID = 'services-gallery';

/*
 * Gallery Default Tag
 */
export const DEFAULT_GALLERY_TAG: Record<ServiceURLs, string> = {
  [URLS.SERVICES.ROOT]: GALLERY_TAG,
  [URLS.SERVICES.DESIGN_AND_BUILD]: 'interior',
  [URLS.SERVICES.DESIGN_AND_RENOVATE]: 'exterior',
};
